"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuNoMarginDivider = exports.VAutoComplete = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var select_1 = require("@blueprintjs/select");
require("@blueprintjs/select/lib/css/blueprint-select.css");
var style_1 = require("./style");
var FormFieldContainer_1 = require("./FormFieldContainer");
var Validators_1 = require("../Validators");
var mobx_1 = require("mobx");
var styled_components_1 = __importDefault(require("styled-components"));
var style_2 = require("../../SelectionList/style");
var ItemSelect = select_1.Suggest.ofType();
var filterItem = function (query, item) {
    return ("".concat(item.label).toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
        (item && item.label === 'No Selection' && item.value === ''));
};
var VAutoComplete = (function (_super) {
    __extends(VAutoComplete, _super);
    function VAutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.renderItem = function (item, _a) {
            var handleClick = _a.handleClick, modifiers = _a.modifiers;
            if (!modifiers.matchesPredicate) {
                return null;
            }
            return (react_1.default.createElement(core_1.MenuItem, { active: false, disabled: modifiers.disabled, label: item.rep, key: item.value, onClick: handleClick, text: item.label }));
        };
        _this.renderMenu = function (_a) {
            var items = _a.items, itemsParentRef = _a.itemsParentRef, query = _a.query, renderItem = _a.renderItem;
            var renderedItems = items.map(renderItem).filter(function (item) { return item != null; });
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(exports.StyledMenuNoMarginDivider, { ulRef: itemsParentRef }, renderedItems.length > 0 ? (renderedItems) : (react_1.default.createElement(core_1.MenuItem, { disabled: true, text: "No results." })))));
        };
        _this.getOptions = function () {
            var options = _this.props.options;
            return options;
        };
        _this.renderInputValue = function (item) { return item.label; };
        _this.disable = function () {
            return _this.props.isLoading ? true : _this.props.disabled;
        };
        _this.renderClearButton = function () { return (react_1.default.createElement(core_1.Button, { style: { width: '30px' }, minimal: true, onClick: _this.onClear, rightIcon: 'filter-remove' })); };
        _this.onClear = function () {
            _this.setState({ query: '' });
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange('');
            }
        };
        _this.onItemSelected = function (value) {
            _this.setState({ item: value });
            if (_this.props.fieldState) {
                _this.props.fieldState.onChange(value.value);
            }
            if (_this.props.onChange) {
                _this.props.onChange(value.value);
            }
        };
        _this.showClear = false;
        return _this;
    }
    Object.defineProperty(VAutoComplete.prototype, "valueField", {
        get: function () {
            if (this.props.fieldState) {
                return this.props.fieldState.value || '';
            }
            if (this.props.value) {
                return this.props.value;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    VAutoComplete.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, label = _c.label, labelInfo = _c.labelInfo, fieldState = _c.fieldState, inline = _c.inline, id = _c.id, options = _c.options, className = _c.className, layer = _c.layer, fill = _c.fill, noLabel = _c.noLabel, required = _c.required, validators = _c.validators, fixedInputWidthPx = _c.fixedInputWidthPx, minimal = _c.minimal, margin = _c.margin, tipLabel = _c.tipLabel, popoverProps = _c.popoverProps, tooltip = _c.tooltip, displayRequired = _c.displayRequired, allowInitialContent = _c.allowInitialContent;
        var initialContent = (options && options.length === 0) || allowInitialContent ? (react_1.default.createElement(core_1.MenuItem, { className: className, disabled: true, text: "".concat(options.length, " items loaded.") })) : (undefined);
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
        return (react_1.default.createElement(style_1.StyledPopOverWrapper, { disabled: this.disable(), inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, fixedInputWidthPx: fixedInputWidthPx, margin: margin },
            react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
                tipLabel && react_1.default.createElement("span", { className: 'tipLabel' }, tipLabel),
                react_1.default.createElement(ItemSelect, { itemPredicate: filterItem, itemRenderer: this.renderItem, items: this.getOptions(), disabled: this.disable(), initialContent: initialContent, onItemSelect: this.onItemSelected, inputValueRenderer: this.renderInputValue, noResults: react_1.default.createElement(core_1.MenuItem, { disabled: true, text: "No results." }), selectedItem: ((_a = this.state) === null || _a === void 0 ? void 0 : _a.item) || undefined, popoverProps: __assign({ minimal: minimal, shouldReturnFocusOnClose: false, modifiers: {
                            arrow: { enabled: true },
                            flip: { enabled: true },
                            keepTogether: { enabled: true },
                            preventOverflow: { enabled: true }
                        } }, popoverProps), resetOnClose: this.props.resetOnClose, className: this.props.isLoading ? core_1.Classes.SKELETON : '', onQueryChange: function (query, event) {
                        _this.setState({ query: query, item: undefined });
                        if (_this.props.onQueryChange) {
                            _this.props.onQueryChange(query, event);
                        }
                    }, query: ((_b = this.state) === null || _b === void 0 ? void 0 : _b.query) || '', inputProps: {
                        rightElement: this.props.allowClear ? (this.renderClearButton()) : (react_1.default.createElement(react_1.default.Fragment, null))
                    } }))));
    };
    __decorate([
        mobx_1.observable
    ], VAutoComplete.prototype, "showClear", void 0);
    __decorate([
        mobx_1.computed
    ], VAutoComplete.prototype, "valueField", null);
    VAutoComplete = __decorate([
        mobx_react_1.observer
    ], VAutoComplete);
    return VAutoComplete;
}(react_1.default.Component));
exports.VAutoComplete = VAutoComplete;
exports.StyledMenuNoMarginDivider = (0, styled_components_1.default)(style_2.NoFocusMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .dividerNoMargin {\n    margin: 0;\n  }\n"], ["\n  & .dividerNoMargin {\n    margin: 0;\n  }\n"])));
var templateObject_1;
